import React from 'react';
import PassportOCRMain from '../../../products/PassportOCRMain';
import { TRY_MODE } from '../../../../common/Utils/Utils';
import AadhaarCardOCR from '../../../products/AadhaarCardOCR';
import { PRODUCT_KEYS } from '../../../../common/productKeys/ProductKeys';
import PancardOCR from '../../../products/PancardOCR';
import EmiratesIdOCR from '../../../products/EmiratesIdOCR';
import AadharMasking from '../../../products/AadharMasking';
import VoterIdOCR from '../../../products/voterIdOCR/VoterIdOCR';
import MalaysianVoterIdOCR from '../../../products/malaysianVoterIdOCR/MalaysianVoterIdOCR';
import MalaysianDLOCR from '../../../products/malaysianDLOCR/MalaysianDLOCR';
import MexicanIdOCR from '../../../products/mexicanIdOCR/MexicanIdOCR';
import UaeVisaOCR from '../../../products/uaeVisaOCR/UaeVisaOCR';
import TryThisOut from '../../../pages/tryNow/TryThisOut';
import { FEATURE_FLAGS } from '../../../../common/config/featureFlags';

/**
 * Product Component Renderer
 *
 * Controls rendering based on ENABLE_DYNAMIC_PRODUCT_CONFIG feature flag:
 * - false: Uses hardcoded product components (LEGACY MODE)
 * - true: Uses dynamic generic renderer (MIGRATION MODE)
 */

const RenderProductComponent = ({ currentProduct, productConfig }) => {
  // Check feature flag to determine which rendering mode to use
  const useDynamicConfig = FEATURE_FLAGS.ENABLE_DYNAMIC_PRODUCT_CONFIG;

  if (!currentProduct?.productKey) {
    return <p>Loading product configuration...</p>;
  }

  // ========================================
  // DYNAMIC MODE (Migration Enabled)
  // ========================================
  if (useDynamicConfig) {
    console.log('🔄 Rendering with DYNAMIC configuration');

    // Extract configuration
    const mode = productConfig?.mode || 'single';
    const previewResponseImage =
      productConfig?.uiConfig?.previewResponseImage || false;

    // Render the generic TryThisOut component with configuration
    return (
      <TryThisOut
        currentProduct={currentProduct}
        productConfig={productConfig}
        mode={mode}
        previewResponseImage={previewResponseImage}
      />
    );
  }

  // ========================================
  // LEGACY MODE (Hardcoded Components)
  // ========================================
  console.log('⚠️ Rendering with LEGACY hardcoded components');

  switch (currentProduct?.productKey) {
    case PRODUCT_KEYS.PASSPORT_OCR:
      return (
        <PassportOCRMain currentProduct={currentProduct} mode={TRY_MODE.DUAL} />
      );

    case PRODUCT_KEYS.AADHAAR_OCR:
      return (
        <AadhaarCardOCR currentProduct={currentProduct} mode={TRY_MODE.DUAL} />
      );

    case PRODUCT_KEYS.PAN_CARD_OCR:
      return <PancardOCR currentProduct={currentProduct} />;

    case PRODUCT_KEYS.EMIRATES_ID_OCR:
      return (
        <EmiratesIdOCR currentProduct={currentProduct} mode={TRY_MODE.DUAL} />
      );

    case PRODUCT_KEYS.AADHAAR_MASK:
      return (
        <AadharMasking
          currentProduct={currentProduct}
          previewResponseImage={true}
        />
      );

    case PRODUCT_KEYS.VOTER_ID_OCR:
      return (
        <VoterIdOCR currentProduct={currentProduct} mode={TRY_MODE.DUAL} />
      );

    case PRODUCT_KEYS.MALAYSIAN_VOTER_ID_OCR:
      return <MalaysianVoterIdOCR currentProduct={currentProduct} />;

    case PRODUCT_KEYS.MALAYSIAN_DRIVING_LICENSE_OCR:
      return <MalaysianDLOCR currentProduct={currentProduct} />;

    case PRODUCT_KEYS.MEXICAN_ID_OCR:
      return (
        <MexicanIdOCR currentProduct={currentProduct} mode={TRY_MODE.DUAL} />
      );

    case PRODUCT_KEYS.UAE_VISA_OCR:
      return <UaeVisaOCR currentProduct={currentProduct} />;

    default:
      return <p>Component not found for this product.</p>;
  }
};

export default RenderProductComponent;
